import { Grid, Table } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { z } from 'zod';

import { schema } from '../../schema';
import { PersonsValidationError } from '../PersonsValidationError/PersonsValidationError';
import { columns } from './PersonsTable.constants';
import { getFullName } from './PersonsTable.helpers';

export const PersonsTable = memo(() => {
    const { control, formState } = useFormContext<z.infer<typeof schema>>();

    const { field, fieldState } = useController({
        name: 'people.persons',
        control,
    });

    const normalizedData = useMemo(
        () =>
            (field.value ?? []).map((person) => ({
                id: person.personId,
                name: getFullName(person),
                ...person,
            })),
        [field.value]
    );

    return (
        <Grid gap={8}>
            <Table
                qa='persons'
                progress={formState.disabled}
                progressRowCount={3}
                columns={columns}
                data={normalizedData}
            />

            <PersonsValidationError message={fieldState.error?.message} />
        </Grid>
    );
});

PersonsTable.displayName = 'PersonsTable';
